export default class RegisterModel {
    constructor(
        public userId?: string,
        public nombre?: string,
        public correoElectronico?: string,
        public contrasena?: string,
        public fechaNacimiento?: string,
        public sexo?: string,
    ) { }
}